import * as React from 'react';
import clsx from 'clsx';

import { Typography } from 'omakase';
import LoadingComponent from '@tock/shared/components/LoadingComponent';

interface Props {
  children?: React.ReactNode;
  heading?: string;
  modifierClassName?: string;
  isLoading: boolean;
}

export default class ConsumerPanel extends React.Component<Props> {
  static defaultProps = {
    isLoading: false,
  };

  render() {
    const { children, heading, isLoading } = this.props;

    return (
      <div className={clsx('ConsumerPanel', this.props.modifierClassName)}>
        {heading && !isLoading && (
          <h3 className="ConsumerPanel-heading">
            <Typography color="inherit" component="span" variant="heading03">
              {heading}
            </Typography>
          </h3>
        )}

        <LoadingComponent
          containerClassName="ConsumerPanel-content"
          isLoading={isLoading}
          isBallPulse={true}
          spinnerClassName="ConsumerPanel-spinner"
        >
          {children}
        </LoadingComponent>
      </div>
    );
  }
}
